import React, { useCallback, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";

interface SuccessModalProps {
    show: boolean;
    onHide: () => void;
    title?: string;
    message?: string;
    subMessage?: string;
    redirectPath?: string;
    redirectButtonText?: string;
    autoRedirect?: boolean;
    redirectDelay?: number;
    iconClass?: string;
    showRedirectButton?: boolean;
    onRedirect?: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
    show,
    onHide,
    title = "Onnistui!",
    message = "Toiminto suoritettu onnistuneesti!",
    subMessage,
    redirectPath,
    redirectButtonText = "Jatka",
    autoRedirect = false,
    redirectDelay = 3000,
    iconClass = "fas fa-check-circle text-success",
    showRedirectButton = true,
    onRedirect,
}) => {
    const history = useHistory();

    const handleRedirect = useCallback(() => {
        onHide();
        if (onRedirect) {
            onRedirect();
        } else if (redirectPath) {
            history.push(redirectPath);
        }
    }, [onHide, onRedirect, redirectPath, history]);

    useEffect(() => {
        if (show && autoRedirect && redirectPath) {
            const timer = setTimeout(() => {
                handleRedirect();
            }, redirectDelay);

            return () => clearTimeout(timer);
        }
    }, [show, autoRedirect, redirectDelay, redirectPath, handleRedirect]);

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center">
                    <div className="mb-3">
                        <i className={iconClass} style={{ fontSize: "3rem" }}></i>
                    </div>
                    <p>{message}</p>
                    {subMessage && <p className="text-muted">{subMessage}</p>}
                </div>
            </Modal.Body>
            {showRedirectButton && (redirectPath || onRedirect) && (
                <Modal.Footer className="justify-content-center">
                    <Button variant="primary" onClick={handleRedirect}>
                        {redirectButtonText}
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default SuccessModal;
